import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ionix = defineConnector({
  identifier: "ionix",
  name: "IONIX",
  tagLine: "External attack surface management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.portal.ionix.io"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Bearer {secrets.apiToken}" },
    },
    { name: "X-Account-Name", value: { from: "config", field: "accountName" } },
    { name: "Accept", value: { from: "literal", value: "application/json" } },
  ]),
  steps: [
    {
      title: "Set up IONIX",
      items: [
        {
          kind: "markdown",
          content:
            "In IONIX, open **Settings → API → Create Token**, create a read-only API key, and note its expiry. Enter the key and your IONIX account name below. Contact IONIX support if you need help finding the account name. See the [official integration setup](https://github.com/Cyberpion-Github/ionix-mcp-server#readme).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.portal.ionix.io",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use https://api.portal.ionix.io, or the API server URL supplied by IONIX for your deployment. Enter the account name separately below.",
        },
        {
          kind: "input",
          label: "Account name",
          required: true,
          target: { kind: "configuration", field: "accountName" },
          helperText:
            "Your IONIX account name, sent in the X-Account-Name header. Contact IONIX support if you need help finding it.",
        },
        {
          kind: "input",
          label: "IONIX API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Create an API key under Settings → API → Create Token. Use read-only access and copy the key securely before leaving the page.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.portal.ionix.io").trim().replace(/\/+$/, "") +
        "/api/v1/remediation/action-items/open/?limit=1",
      ...{ method: "GET" },
    }),
  },
});
